import { filterDOMProps } from '@react-aria/utils';
import type { GridProps } from '@react-types/layout';
import type { DOMRef } from '@react-types/shared';
import React, { forwardRef } from 'react';
import { useDOMRef } from '../../../utils';

function Grid(props: GridProps, ref: DOMRef<HTMLDivElement>) {
  let { children, ...otherProps } = props;
  let domRef = useDOMRef(ref);

  return (
    <div
      {...filterDOMProps(otherProps)}
      className={props.UNSAFE_className}
      style={props.UNSAFE_style}
      ref={domRef}
    >
      {children}
    </div>
  );
}

const _Grid = forwardRef(Grid);
export { _Grid as Grid };
